/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Wrapped_ReadyInputs */

const en_us2_progress_wrapped_ready = /** @type {(inputs: Progress_Wrapped_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last week, as story cards`)
};

const pt_br2_progress_wrapped_ready = /** @type {(inputs: Progress_Wrapped_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana passada em cartões`)
};

const es_419_progress_wrapped_ready = /** @type {(inputs: Progress_Wrapped_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La semana pasada, en tarjetas`)
};

const pt_pt2_progress_wrapped_ready = /** @type {(inputs: Progress_Wrapped_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A semana passada em cartões`)
};

const fr_fr2_progress_wrapped_ready = /** @type {(inputs: Progress_Wrapped_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La semaine dernière, en cartes`)
};

const de_de2_progress_wrapped_ready = /** @type {(inputs: Progress_Wrapped_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Woche als Story-Karten`)
};

const it_it2_progress_wrapped_ready = /** @type {(inputs: Progress_Wrapped_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La settimana scorsa, in schede`)
};

/**
* | output |
* | --- |
* | "Last week, as story cards" |
*
* @param {Progress_Wrapped_ReadyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_wrapped_ready = /** @type {((inputs?: Progress_Wrapped_ReadyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Wrapped_ReadyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_wrapped_ready(inputs)
	if (locale === "es-419") return es_419_progress_wrapped_ready(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_wrapped_ready(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_wrapped_ready(inputs)
	if (locale === "de-DE") return de_de2_progress_wrapped_ready(inputs)
	if (locale === "it-IT") return it_it2_progress_wrapped_ready(inputs)
	return en_us2_progress_wrapped_ready(inputs)
});
export { progress_wrapped_ready as "progress.wrapped_ready" }